import { Body, Button, Heading, Toast } from '@hover/blueprint';
import { iconSaveOutlined } from '@hover/icons';
import React from 'react';
import { useHistory, useLocation } from 'react-router';

import {
  useAiDisplayImageQuery,
  useGetProjectsQuery,
} from 'src/shared/graphql/generated';

import { useHomeownerTranslate, useSaveToProject } from '../../hooks';
import { saveToProjectSchema } from '../../schemas';
import type { ToastPresenceProps } from '../ToastPresence';
import { ToastPresence } from '../ToastPresence';

export interface SaveToProjectToastProps extends ToastPresenceProps {}

export const SaveToProjectToast = (props: SaveToProjectToastProps) => {
  const t = useHomeownerTranslate();

  const history = useHistory();
  const { state, pathname } = useLocation();

  const id = saveToProjectSchema.isValidSync(state)
    ? state.aiDisplayImageId
    : null;

  const { projects } = useGetProjectsQuery().data ?? {};
  const { aiDisplayImage: image } =
    useAiDisplayImageQuery({
      variables: { id: id ?? 0 },
      skip: !id,
    }).data ?? {};

  const { handleSave } = useSaveToProject({
    image,
    location: 'post-edit-fullscreen',
  });

  const handleClose = () => history.replace(pathname, null);

  const hasNoProjects = !!projects && projects.length === 0;
  const isVisible = !!id && hasNoProjects;

  return (
    <ToastPresence
      alignItems="stretch"
      display="flex"
      flexDirection="column"
      isVisible={isVisible}
      {...props}
    >
      <Toast
        alignItems="start"
        direction="column"
        message={undefined}
        onClose={handleClose}
        padding="500"
        role="alert"
        variant="content"
      >
        <Heading size="xs">
          {t('customize.saveToProjectToast.bringThisIdeaToLife')}
        </Heading>
        <Body mb="400" mt={0} size="small">
          {t('customize.saveToProjectToast.keepAllYourIdeasInOnePlace')}
        </Body>
        <Button
          height="350"
          iconAfter={iconSaveOutlined}
          onClick={() => {
            handleSave();
            handleClose();
          }}
          px="400"
        >
          {t('projects.save')}
        </Button>
      </Toast>
    </ToastPresence>
  );
};
